// typeMap — Item 타입별 lucide-react 아이콘 + 레이블 매핑 (U42).
// Explorer.tsx의 TYPE_LABEL과 동일한 12종을 통합 관리.

import {
  KeyRound,
  Key,
  Server,
  FileCode2,
  Lock,
  StickyNote,
  Globe,
  Database,
  Link2,
  CreditCard,
  File,
  ListChecks,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ItemType } from '../../api/items';

/** 타입 → Lucide 아이콘 컴포넌트 매핑 */
export const TYPE_ICON_MAP: Record<ItemType, LucideIcon> = {
  credential_account: KeyRound,
  credential_api_key: Key,
  credential_server: Server,
  credential_env: FileCode2,
  credential_auth: Lock,
  note: StickyNote,
  server: Database,
  domain: Globe,
  service: Link2,
  subscription: CreditCard,
  file: File,
  checklist: ListChecks,
};

/** 타입 → 한국어 레이블 매핑 */
export const TYPE_LABEL: Record<ItemType, string> = {
  credential_account: '계정',
  credential_api_key: 'API 키',
  credential_server: '서버 접속',
  credential_env: '.env',
  credential_auth: '인증',
  note: '메모',
  server: '서버 인프라',
  domain: '도메인',
  service: '서비스',
  subscription: '구독',
  file: '파일',
  checklist: '체크리스트',
};
